
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Card from 'vux/src/components/card/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Badge from 'vux/src/components/badge/index.vue'



export default {
data() {
return {
myDoneResult: {
finishCount: 0,
errorCount: 0,
finishRate: 0,
totalcount: 0
},
unReadCount: 0,
gridHeight: 300,
screenHeight: document.body.clientHeight
};
},
created() {
this.initAgentCode();
this.initUserInfo();

this.initSubjectInfo();
this.initNotice();
this.initSettingInfo();
},
mounted() {
this.$nextTick(() => {
if(!document.getElementById("grid")) return;
var height = document.getElementById("grid").offsetHeight;
this.gridHeight = height > 250 ? height : 250;
});

const that = this;
window.onresize = () => {
return (() => {
window.screenHeight = document.body.clientHeight;
that.screenHeight = window.screenHeight;
})();
};
},
activated() {

this.initSubjectInfo();
this.initNotice();


if (this.ClassInfo != undefined && this.ClassInfo.IsNew) {
this.ClassInfo.IsNew = false;
this.$store.commit("$_setClassInfo", this.ClassInfo);
}
},
components: {
XHeader,
Swiper,
SwiperItem,
Card,
Grid,
GridItem,
GroupTitle,
Tabbar,
TabbarItem,
Badge
},
methods: {
initAgentCode() {
var agentCode = this.$route.query.agent;
if (agentCode != undefined) {
var localConfigInfo = this.$store.getters.getConfigInfo;
if (localConfigInfo != undefined) {
localConfigInfo.AgentCode = agentCode;
} else {
localConfigInfo = {
AgentCode: agentCode
};
}
this.$store.commit("$_setConfigInfo", localConfigInfo);
}
},
initUserInfo() {
if (this.UserInfo == undefined || this.ClassInfo == undefined) {
if (process.env.NODE_ENV == "development") {

var courseId = this.$route.query.course;
if (courseId != undefined) {
var localClassInfo = {
RefCourseId: courseId
};
this.$store.commit("$_setClassInfo", localClassInfo);
window.location.replace("http://127.0.0.1:8080/#/");
}


this.$http({
method: "get",
url: "wxexam.ashx?op=LoadCustomerInfo",
params: {
cusId: 3035666
}
})
.then(response => {
console.log(response.data);
if (response.status == 200 && response.data.errcode == 0) {
this.initUserInfoByUser(response.data.data[0]);
}
})
.catch(function(error) {
console.log("error:" + error);
});
return;
}

var code = this.getQueryString("code");
if (code) {

this.$http({
method: "get",
url: "/wxexam.ashx?op=login",
params: {
code: code
}
}).then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.initUserInfoByUser(response.data.data[0]);
}
});
} else {

var courseId = this.$route.query.course;
if (courseId != undefined) {
var localClassInfo = {
RefCourseId: courseId
};
this.$store.commit("$_setClassInfo", localClassInfo);
}


this.$http({
method: "get",
url: "wxexam.ashx?op=GetCodeUrl",
params: {
redirect_uri: "http://wx.jinkaodian.com"
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode && response.data.errcode != 0) {
this.$vux.toast.text(response.data.errmsg, "bottom");
} else {
window.location.replace(response.data);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
} else if (this.ClassInfo.CourseId == 0) {

this.$router.push({
path: "/ClassList"
});
}
},
initUserInfoByUser(user) {
var localUserInfo = {
CusId: user.icusid,
CusName: user.ccusname,
DcCode: user.cdccode,
HeadImgUrl: user.cheadimgurl
};
this.$store.commit("$_setUserInfo", localUserInfo);

if (this.ClassInfo != undefined && this.ClassInfo.RefCourseId > 0) {
this.initClassInfoByQuery();
} else {
var localClassInfo = {
CourseId: user.icourseid,
CourseName: user.ccoursename,
IsNew: false
};
this.$store.commit("$_setClassInfo", localClassInfo);
}

if (user.icourseid == 0) {
this.$router.push({
path: "/ClassList"
});
} else {
this.initSubjectInfo();
this.initSettingInfo();
this.initNotice();
}
},
initClassInfoByQuery() {

var courseId = this.ClassInfo.RefCourseId;

if (courseId != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=LoadCourseInfo",
params: {
courseId: courseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
var localClassInfo = {
CourseId: courseId,
CourseName: response.data.data[0].ccoursename,
IsNew: false
};
this.$store.commit("$_setClassInfo", localClassInfo);
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
initSubjectInfo() {
if (this.UserInfo != undefined && this.ClassInfo != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=LoadMyDoneResultOfSubject",
params: {
cusId: this.UserInfo.CusId,
courseId: this.ClassInfo.CourseId,
errPeriodType: 0
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
var finishRate = 0;
if (response.data.finishcount > 0) {
finishRate =
(1 - response.data.errorcount / response.data.finishcount) *
100;
}
if (finishRate < 0) {
finishRate = 0;
}

this.myDoneResult = {
finishCount: response.data.finishcount,
errorCount: response.data.errorcount,
finishRate: finishRate,
totalcount: response.data.totalcount
};
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
initNotice() {
if (this.UserInfo != undefined && this.ClassInfo != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=GetPhoneMessageUnReadCount",
params: {
userId: this.UserInfo.CusId,
courseId: this.ClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
if (parseInt(response.data.data) > 0) {
this.unReadCount = parseInt(response.data.data);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
initSettingInfo() {
if (this.UserInfo != undefined && this.ClassInfo != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=GetExamSettings",
params: {
cusId: this.UserInfo.CusId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
var settings = response.data;
var localSettingInfo = {
FontSize: settings.fontsize,
LongBright: settings.longbright,
NightMode: settings.nightmode
};
this.$store.commit("$_setSettingInfo", localSettingInfo);
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
chapterExercise(type) {
this.$http({
method: "post",
url: "wxexam.ashx?op=GetCourseLastTestSubjectId",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0 && response.data.data.length > 0) {
const _this = this;
var data = response.data.data[0];
var chapterid = data.ichapterid;
var subjectid = data.isubjectid;
this.$vux.confirm.show({
title: "章节练习",
content: "是否回到上次练习的试题？",
onConfirm() {
_this.startSubjuect(chapterid, subjectid);
},
onCancel() {
_this.startChapterExercise(type);
}
});
return;
}
}

this.startChapterExercise(type);
})
.catch(function(error) {
console.log("error:" + error);
this.startChapterExercise(type);
});
},
startChapterExercise(type) {
if (type == 0) {
this.$router.push({
path: "/ChapterExercise",
query: {
type: 0,
showTitle: "题库练习",
index: 1
}
});
} else if (type == 1) {
this.$router.push({
path: "/ChapterExercise",
query: {
type: 1,
showTitle: "真题试卷",
index: 1
}
});
}else if (type == 2) {
this.$router.push({
path: "/ChapterExercise",
query: {
type: -1,
gotoquick: 1,
showTitle: "快速背题",
index: 1
}
});
}
},
startSubjuect(chapterid, subjectid) {
this.$router.push({
path: "/SubjuectData",
query: {
chapterid: chapterid,
subjectid: subjectid,
showtime: this.GLOBAL.SubjectShowTime.Test
}
});
},
showVideo() {
if (this.videoUrl.length == 0) {
return;
}

window.location.href = this.videoUrl;
},
onMessage() {

this.$router.push({
path: "/MessageList"
});
},
onSetting() {

this.$router.push({
path: "/Setting"
});
},
onChatQQ() {

window.location.href =
"http://wpa.qq.com/msgrd?v=3&uin=1900076751&site=qq&menu=yes";

},
onSearch() {

this.$router.push({ path: "/SearchSubject" });
},
onMy() {

this.$router.replace({ path: "/My" });
},
onOpenUrl() {
window.location.href =
"http://wap.wangxiao.cn/agent/home/?agent=jinkaodian";
},
onChapter() {
this.$router.push({
path: "/ChapterExercise",
query: {
type: 0,
showTitle: "答题",
index: 1
}
});
},
onMyClass() {
this.$router.push({
path: "/MyClassList"
});
},
showPosition(position) {
this.$vux.toast.text("暂不开放", position);
},

getQueryString(name) {
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
var r = window.location.search.substr(1).match(reg);
if (r != null) {
return unescape(r[2]);
}
return null;
}
},
computed: {
UserInfo: function() {
return this.$store.getters.getUserInfo;
},
ClassInfo: function() {
return this.$store.getters.getClassInfo;
},
ShowCourseName: function() {
return this.ClassInfo != undefined ? this.ClassInfo.CourseName : "";
}
},
watch: {
screenHeight(val) {
if(!document.getElementById("grid")) return;
var height = document.getElementById("grid").offsetHeight;
if(height)
this.gridHeight = height > 250 ? height : 250;
}
}
};



// WEBPACK FOOTER //
// ./src/components/Index.vue